module.exports = __webpack_public_path__ + "img/structures3.c7fd2a06.svg";